import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { ExternalLink } from 'lucide-react';

const Projects = ({ data }) => {
  return (
    <section id="projects" className="py-24 bg-[#0a0a0a] border-t border-[#2a2a2a]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Featured Projects</h2>
          <p className="text-[#a3a3a3] text-lg">Key data architecture and governance initiatives I've led across enterprise organizations.</p>
        </div>

        {/* Projects Grid */}
        <div className="space-y-12">
          {data.projects.map((project) => (
            <Card key={project.id} className="bg-[#161616] border-[#2a2a2a] p-8 md:p-10 hover:border-white transition-all duration-300 hover:transform hover:-translate-y-1">
              {/* Project Header */}
              <div className="mb-6">
                <div className="flex items-center gap-3 mb-2">
                  <Badge className="bg-white text-black text-xs font-semibold px-3 py-1">{project.role}</Badge>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">{project.title}</h3>
                <p className="text-[#a3a3a3] text-lg leading-relaxed">{project.description}</p>
              </div>

              {/* Responsibilities */}
              <div className="mb-6">
                <h4 className="text-white font-semibold mb-4">Roles & Responsibilities</h4>
                <ul className="space-y-2">
                  {project.responsibilities.map((resp, idx) => (
                    <li key={idx} className="text-[#a3a3a3] text-sm leading-relaxed flex items-start">
                      <span className="text-white mr-2 mt-1">•</span>
                      <span>{resp}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Technologies */}
              <div className="flex flex-wrap gap-2">
                {project.technologies.map((tech, index) => (
                  <Badge 
                    key={index}
                    variant="outline"
                    className="bg-[#0a0a0a] border-[#2a2a2a] text-[#a3a3a3] px-3 py-1.5 text-xs font-mono cursor-default"
                  >
                    {tech}
                  </Badge>
                ))}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
